import { useContext, useState } from 'react';
import { SegmentedButtons } from '@scale/scaleui';
import ResponseTemplateCreatorOriginal from './ResponseTemplateCreatorOriginal';
import ResponseTemplateCreatorInline from './ResponseTemplateCreatorInline';
import { InlineResponseTemplatingContextProvider } from 'react-scale/components/scalers/tasks/ThreadedInteraction/contexts/InlineResponseTemplatingContextProvider';
import { useChatStoreExtract } from '../../Chat/hooks/ChatStore.hooks';
import { ChatTaskContext } from '../contexts/ChatTaskContext';

enum ResponseTemplateMode {
  Original = 'Original',
  Inline = 'Inline',
}

function ResponseTemplateCreatorDemo() {
  const [mode, setMode] = useState<ResponseTemplateMode>(ResponseTemplateMode.Original);

  const taskContext = useContext(ChatTaskContext);

  const config = useChatStoreExtract(state => state.config);
  const responses = useChatStoreExtract(state => state.responses);
  const setResponses = useChatStoreExtract(state => state.setResponses);
  const reviewLevel = useChatStoreExtract(state => state.reviewLevel);

  return (
    <div className="flex-1 flex flex-col min-w-[1080px] gap-6">
      <SegmentedButtons
        buttons={[
          {
            id: ResponseTemplateMode.Original as string,
            label: ResponseTemplateMode.Original,
          },
          {
            id: ResponseTemplateMode.Inline as string,
            label: ResponseTemplateMode.Inline,
          },
        ]}
        onSelect={r => setMode(r as ResponseTemplateMode)}
        selected={mode as string}
      />
      {mode === ResponseTemplateMode.Original && (
        /**
         * Creates it's own ChatStore and syncs responses with parent,
         * Only syncs responses with parent (not config, reviewLevel, etc.)
         */
        <ResponseTemplateCreatorOriginal
          config={config}
          context={taskContext}
          previewReviewLevel={reviewLevel}
          templateResponses={responses}
          setTemplateResponses={setResponses}
        />
      )}
      {mode === ResponseTemplateMode.Inline && (
        /**
         * Creates it's own ChatStore and syncs responses with parent,
         * Only syncs responses with parent (not config, reviewLevel, etc.)
         */
        <InlineResponseTemplatingContextProvider
          config={config}
          templatedResponses={responses}
          setTemplatedResponses={setResponses}
          reviewLevel={reviewLevel}
        >
          <ResponseTemplateCreatorInline
            config={config}
            context={taskContext}
            previewReviewLevel={reviewLevel}
          />
        </InlineResponseTemplatingContextProvider>
      )}
    </div>
  );
}

export default ResponseTemplateCreatorDemo;
